"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceHeaderMetadataCertification = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var SpacesCaptionCertified_1 = require("../../../gen-src/icons/SpacesCaptionCertified");
var PlaceHeaderMetadataTableauUser_1 = require("./PlaceHeaderMetadataTableauUser");
var placeHeaderCertificationIcon = React.createElement(SpacesCaptionCertified_1.SvgSpacesCaptionCertified, { className: data_catalog_shared_1.certificationIconStyle });
/**
 * Renders the certification icon/popup alongside text showing the name of the certifier,
 * for use in place page headers.
 * @param props
 */
function PlaceHeaderMetadataCertification(props) {
    var _a, _b, _c, _d;
    var dqcertificationVisualDesignEnabled = React.useContext(data_catalog_shared_1.FeatureFlagsContext).dqcertificationVisualDesignEnabled;
    var urls = React.useContext(data_catalog_shared_1.SiteUrlsContext);
    var certifier = props.certification.certifier;
    if (!props.certification.isCertified || !certifier) {
        return null;
    }
    if (dqcertificationVisualDesignEnabled) {
        if (props.dataQualityCertifications.length > 0) {
            return (React.createElement(data_catalog_shared_1.CertificationStatusChipOrIcon, { kind: 'graph', urls: urls, iconOnly: false, subjectArea: props.subjectArea, anchoredAsset: props.anchoredAsset, anchoredCertifications: [{
                        __typename: 'DataQualityCertification',
                        vizportalId: props.vizportalId,
                        author: props.dataQualityCertifications[0].author,
                        authorDisplayName: (_b = (_a = props.dataQualityCertifications[0].author) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '',
                        message: props.dataQualityCertifications[0].message,
                        isActive: props.dataQualityCertifications[0].isActive,
                        updatedAt: new Date(props.dataQualityCertifications[0].updatedAt)
                    }] }));
        }
        else {
            return (React.createElement(data_catalog_shared_1.CertificationStatusChipOrIcon, { kind: 'graph', urls: urls, iconOnly: false, subjectArea: props.subjectArea, anchoredAsset: props.anchoredAsset, anchoredCertifications: [{
                        __typename: 'DataQualityCertification',
                        vizportalId: props.vizportalId,
                        author: props.certification.certifier,
                        authorDisplayName: (_d = (_c = props.certification.certifier) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '',
                        message: props.certification.certificationNote,
                        isActive: props.certification.isCertified,
                        updatedAt: ''
                    }] }));
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(data_catalog_shared_1.CertificationWidget, __assign({ icon: placeHeaderCertificationIcon }, props)),
        React.createElement(PlaceHeaderMetadataTableauUser_1.PlaceHeaderMetadataTableauUser, { tableauUser: certifier, labelText: Localize_1.Messages.CertifiedBy() })));
}
exports.PlaceHeaderMetadataCertification = PlaceHeaderMetadataCertification;
//# sourceMappingURL=PlaceHeaderMetadataCertification.js.map